import { useSnapshot } from 'valtio'

import { executionEventMarkers } from '../executionEventMarkers'

export function useActivePodMarker() {
  return useSnapshot(executionEventMarkers).pod
}
